var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Icon = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 auto;\n\n    rect {\n        stroke: ", ";\n    }\n"], ["\n    margin: 0 auto;\n\n    rect {\n        stroke: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorControlIcon;
});
export default (function () { return (React.createElement(Icon, { viewBox: "0 0 17 5", width: "17", height: "5" },
    React.createElement("g", { className: "summary-tile-menu-icon", strokeWidth: "1", fill: "none" },
        React.createElement("rect", { id: "dot1", x: "0.5", y: "0.5", width: "4", height: "4" }),
        React.createElement("rect", { id: "dot2", x: "6.5", y: "0.5", width: "4", height: "4" }),
        React.createElement("rect", { id: "dot3", x: "12.5", y: "0.5", width: "4", height: "4" })))); });
var templateObject_1;
//# sourceMappingURL=ThreeDots.js.map